import { AES, enc, SHA256 } from 'crypto-js';

export class SecureUtils {
  /**
   * Encrypt a String using an specific key
   * @param input String to encrypt
   * @param encryptKey to use in the process
   * @return Encrypted string
   */
  static encryptWithKey(input: string, encryptKey: string) {
    if (input == null || encryptKey == null) {
      return null;
    }
    const ciphertext = AES.encrypt(JSON.stringify(input), encryptKey);
    return ciphertext.toString();
  }

  /**
   * Decrypt an encrypted string using an specific key
   * @param input String to decrypt
   * @param encryptKey to use in the process
   * @return Decrypted string
   */
  static decryptWithKey(input: string, encryptKey: string) {
    if (input == null || encryptKey == null) {
      return null;
    }
    const bytes = AES.decrypt(input, encryptKey);
    try {
      const plaintext = bytes.toString(enc.Utf8);
      if (plaintext.length === 0) {
        return null;
      }
      return JSON.parse(plaintext);
    } catch (err) {
      return null;
    }
  }

  /**
   * Using sha-512. The hash algorithms accept a string to obtain the hash. Operate on 64-bit words
   * @param input to hash
   */
  static getHashFrom(input: string) {
    return SHA256(input).toString().toUpperCase();
  }

  static generateRandomSecret() {
    return window.crypto.getRandomValues(new Uint32Array(10)).join('');
  }
}
